import { ApiClient, getTenantFeatureToggle } from '@ori/static-api-client-react';

import { USE_INDEXED_DB_FT_GUID } from '../constants';
import { logDebug, mainLogger } from '../logger';
import type { ClientAppConfig } from '../types';

export async function getUseIndexedDbFeatureToggle({
  currentLanguage,
  staticApiUrl,
  tenant,
}: Pick<ClientAppConfig, 'currentLanguage' | 'staticApiUrl' | 'tenant'>) {
  logDebug('Getting useIndexedDbStorage feature toggle ...');
  let result = false;
  try {
    const staticApiClient = new ApiClient({ baseUrl: staticApiUrl, language: currentLanguage, tenant });
    const {
      data: { isEnabled },
    } = await getTenantFeatureToggle(staticApiClient, tenant, USE_INDEXED_DB_FT_GUID);
    logDebug('FT value loaded:', isEnabled);
    result = isEnabled;
  } catch (error) {
    mainLogger.error(error as Error, { message: 'Error while loading UseIndexedDb feature toggle.' });
  }

  return result;
}
